import Comm from "./BaseComm";
import IComm from "./IComm";
import { IRequestBuilder } from "../server/requests/RequestBuilder";
import { BaseModel } from "../model/BaseModel";

class CommManager {

    protected comm: IComm;
    protected modelUpdateQueue: BaseModel<any>[];

    constructor() {
        this.comm = new Comm();
    }

    /**
     * Alow overriding of default comm module for edge casses (Max Win gaming for example)
     */
    public setComm(comm?: IComm) {
        this.comm = comm || new Comm();
    }

    public registerModelUpdate(model: BaseModel<any>) {
        if (!this.modelUpdateQueue) {
            this.modelUpdateQueue = [];
        }
        if (model) {
            this.modelUpdateQueue.push(model);
        }
    }

    send(request: IRequestBuilder, callback: (...args: any[]) => void, callbackScope: any, errorCallback?: (...args: any[]) => void, POSTWithCredentials = false) {
        callback = callback == undefined ? this.emptyFunc() : callback.bind(callbackScope);
        const combinedCallback = (...args: any[]) => {
            this.precallback(...args);
            callback(...args);
        }

        errorCallback = errorCallback == undefined ? this.emptyFunc() : errorCallback.bind(callbackScope);

        if (!request.path) {
            callback();
        } else {
            this.comm.send(request, combinedCallback, callbackScope, errorCallback, POSTWithCredentials);
        }
    }

    precallback(...args: any[]) {
        if (this.modelUpdateQueue) {
            this.modelUpdateQueue.forEach(model => {
                model.update(...args);
            })
        }
    }

    emptyFunc() {
    }
}

export default new CommManager();
